import api, { handleAPIErrors } from "shared/api";

const FETCH_LATEST_REQUEST = "boardSummaryReports/FETCH_LATEST_REQUEST";
const FETCH_LATEST_SUCCESS = "boardSummaryReports/FETCH_LATEST_SUCCESS";
const FETCH_LATEST_FAILURE = "boardSummaryReports/FETCH_LATEST_FAILURE";

const initialState = {
  latestReport: null,
  loaded: false,
  loading: false,
  errors: [],
};

export function fetchLatestRequest() {
  return {
    type: FETCH_LATEST_REQUEST,
  };
}

export function fetchLatestSuccess(payload) {
  return {
    type: FETCH_LATEST_SUCCESS,
    payload,
  };
}

export function fetchLatestFailure(errors = []) {
  return {
    type: FETCH_LATEST_FAILURE,
    errors,
  };
}

export function loadLatestBoardSummaryReport() {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(fetchLatestRequest());

    const promise = api("api/v1/board_summary_reports/latest")
      .then((response) => response.json().then((json) => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json);
        }

        dispatch(fetchLatestSuccess(json));
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchLatestFailure(errors));
        });
      });

    return promise;
  };
}

export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action;

  switch (type) {
    case FETCH_LATEST_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });
    case FETCH_LATEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        errors: [],
        latestReport: payload,
      });
    case FETCH_LATEST_FAILURE:
      return Object.assign({}, state, {
        loaded: false,
        loading: false,
        errors,
      });
    default:
      return state;
  }
}
